import React, {
    useState, useCallback, useEffect
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useValidation } from 'gw-portals-validation-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';

import metadata from './LossLocation.metadata.json5';
import styles from './LossLocation.module.scss';
import './LossLocation.messages';

function FNOLCPLossLocation(props) {
    const {
        id, onValidate, path: claimVM, updatePath: updateWizardData
    } = props;
    const [policyAddressDropdown, updatePolicyAddressDropdown] = useState(null);
    const {
        isComponentValid,
        registerComponentValidation
    } = useValidation(id);

    const handleAddressDropDownValueChange = useCallback(
        (addressIndex) => {
            const updatedLocations = claimVM.predefinedLossLocations
                .value.find((loss, index) => {
                    return index === parseInt(addressIndex, 10);
                });
            _.set(claimVM.value, 'optionalLossLocation.predefinedAddress', updatedLocations);
            updatePolicyAddressDropdown(addressIndex);
            const getLocations = { ...updatedLocations, country: 'US' };
            _.set(claimVM.value, 'lossLocation_Ext', getLocations);
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );

    useEffect(() => {
        registerComponentValidation(() => {
            if (!_.isNil(policyAddressDropdown)) {
                return claimVM.lossLocation_Ext.aspects.valid
                    && claimVM.lossLocation_Ext.aspects.subtreeValid;
            }
            return false;
        });
    }, [claimVM, registerComponentValidation, policyAddressDropdown]);

    useEffect(() => {
        const locationValue = _.get(claimVM.value, 'optionalLossLocation.predefinedAddress');
        if (!_.isUndefined(locationValue)) {
            const adressIndex = _.findIndex(claimVM.predefinedLossLocations.value, (item) => {
                return item.displayName === locationValue.displayName;
            });
            handleAddressDropDownValueChange(adressIndex);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const lossLocation = _.get(claimVM, 'lossLocation_Ext.value', {});
        const predefinedLossLocations = _.get(claimVM, 'predefinedLossLocations.value', []);
        if (!_.isEmpty(lossLocation)) {
            const selectedLocationIndex = predefinedLossLocations
                && predefinedLossLocations.findIndex((location) => {
                    return location.displayName === lossLocation.displayName;
                });
            updatePolicyAddressDropdown(
                selectedLocationIndex !== -1
                    ? _.toString(selectedLocationIndex)
                    : ''
            );
        }
        if (
            claimVM
            && claimVM.predefinedLossLocations.value.length === 1
        ) {
            handleAddressDropDownValueChange(0);
        }
        // All dependency is not required here. If we add all looping and hang the page.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidate]);

    const getPreferredAddressDropDownValues = useCallback(
        () => {
            if (claimVM && claimVM.value.predefinedLossLocations) {
                const addressData = claimVM.value.predefinedLossLocations;
                return addressData.map((address, index) => {
                    const addressJoin = [
                        address.addressLine1,
                        address.addressLine2,
                        address.addressLine3,
                        address.city,
                        address.state,
                        address.postalCode
                    ];

                    const addressArrayJoin = _.values(addressJoin)
                        .filter((value) => !!value)
                        .join(', ');
                    const addressArrayJoinKey = {
                        code: _.toString(index),
                        name: addressArrayJoin
                    };
                    return addressArrayJoinKey;
                });
            }

            return [];
        }, [claimVM]
    );

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showOptional: true
        },
        selectAddress: {
            availableValues: getPreferredAddressDropDownValues(),
            value: policyAddressDropdown,
            onValueChange: handleAddressDropDownValueChange,
            required: true,
            visible: claimVM
            && claimVM.value.predefinedLossLocations
            && claimVM.value.predefinedLossLocations.length > 1
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (fieldId, path) => {
            return readViewModelValue(
                metadata.pageContent,
                claimVM.lossLocation_Ext,
                fieldId,
                path,
                overrideProps
            );
        },
        [claimVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={claimVM.lossLocation_Ext}
            overrideProps={overrideProps}
            resolveValue={readValue}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}
FNOLCPLossLocation.propTypes = {
    id: PropTypes.string.isRequired,
    path: PropTypes.shape({}).isRequired,
    onValidate: PropTypes.func.isRequired,
    updatePath: PropTypes.func.isRequired
};
export default FNOLCPLossLocation;
